import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters, mapState } from "vuex";
import { LOAD_BOARDS } from "@Broker/@Modules/clients/board/store/board-actions";
import { BOARDS } from "@Broker/@Modules/clients/board/store/board-getters";
import { isEmpty } from "lodash";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BoardSelect",
  components: {
    vSelectField
  },
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: null
    },
    value: {
      type: [Array, String],
      default: () => null
    },
    materialDesign: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    },
    spaceClasses: {
      type: String,
      default: "col-12 mt-3 pb-4 px-0"
    },
    currentUsername: {
      type: String,
      default: ""
    },
    formGroupClass: {
      type: String,
      default: ""
    },
    options: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: String,
      default: "boards-select"
    }
  },
  data() {
    return {
      allReferrers: [],
      vSelectOptions: [],
      defaultValue: ""
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("BoardStore", ["defaultBoardId", "boards"])), mapGetters("BoardStore", [BOARDS])), {}, {
    groupClass() {
      const cssClass = this.formGroupClass.split(" ");
      if (this.materialDesign) cssClass.push("form-group-material");else cssClass.push("form-group");
      return cssClass.join(" ");
    },
    boardsOptions() {
      return _Object$values(this.boards.byId);
    }
  }),
  mounted() {
    if (isEmpty(this.boardsOptions)) {
      this.LOAD_BOARDS().then(() => {
        this.$nextTick(() => {
          var _context, _context2;
          this.vSelectOptions = _mapInstanceProperty(_context = this.boardsOptions).call(_context, board => {
            return _objectSpread({
              label: board.name,
              value: board.id
            }, board);
          });
          this.defaultValue = _findInstanceProperty(_context2 = this.vSelectOptions).call(_context2, board => board.value === this.value);
        });
      });
    } else {
      var _context3, _context4;
      this.vSelectOptions = _mapInstanceProperty(_context3 = this.boardsOptions).call(_context3, board => {
        return _objectSpread({
          label: board.name,
          value: board.id
        }, board);
      });
      this.defaultValue = _findInstanceProperty(_context4 = this.vSelectOptions).call(_context4, board => board.value === this.value);
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [LOAD_BOARDS])), {}, {
    handleChange(data, type) {
      var _context5, _context6;
      this.defaultValue = _findInstanceProperty(_context5 = this.vSelectOptions).call(_context5, option => option === data);
      const dataToEmit = _findInstanceProperty(_context6 = this.BOARDS).call(_context6, board => board.id === data.value);
      this.$emit("change", dataToEmit, type);
    }
  })
});